<template>
  <div class="find_menu">
    <a class="btn_txt pointer no-drag" @click="clickMenu('signUp')">{{ $t('account.sign_up') }}</a>
    <span>|</span>
    <a class="btn_txt pointer no-drag" @click="clickMenu('login')">{{ $t('account.login') }}</a>
  </div>
</template>
<script>
export default {
  name: 'FindPwFooter',
  methods: {
    clickMenu(path) {
      this.$router.push(`/${path}`);
    }
  }
}
</script>